import React, { useEffect } from 'react';
import { noticeWebSocketService } from '@/utils/noticeWebSocket';

/** 登录后建立 WebSocket 连接，接收通知并展示 */
const NoticeWebSocket: React.FC = () => {
  useEffect(() => {
    noticeWebSocketService.connect();
    return () => {
      noticeWebSocketService.disconnect();
    };
  }, []);

  return null;
};

export default NoticeWebSocket;
